// assets/modal-inicial.js
class ModalInicial extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        // MODAL INICIAL DE HORARIO ATENCION
        this.modalMensajeHorarioAtencion = this.querySelector('#phmi-mensaje-horario-atencion');
        this.modalMensajeSolicitudEntrega = this.querySelector('#phmi-mensaje-solicitud-entrega');

        // CONTENEDOR GENERAL DEL MODAL
        this.modalGeneral = document.querySelector('.modal-general-sme');
        this.modalGeneralCarga = document.querySelector('#ph-general-modal-carga');
        // BOTONES DE SELECCION METODO ENTREGA
        this.btnRecogerLocal = document.querySelector('#mpsme-recoger-local');
        this.btnEnvioDomicilio = document.querySelector('#mpsme-envio-domicilio');
        this.iconoSeleccionRecogerLocal = document.querySelector('#mpsme-icono-recoger-local');
        this.iconoSeleccionEnvioDomicilio = document.querySelector('#mpsme-icono-envio-domicilio');
        // OPCIONES DEL MODAL
        this.containerModalMenu = this.querySelector('.h-menu-opciones-productos');
        this.btnContinuarHorarioAtencion = this.querySelector('#mpsme-opcion-continuar-horario-atencion');
        this.btnContinuar = document.querySelector('#mpsme-opcion-continuar');
        this.btnOmitir = document.querySelector('#mpsme-opcion-omitir');
        // LISTENER DE EVENTOS
        this.btnOmitir.addEventListener('click', this.omitirBtnModal.bind(this));
        this.btnContinuar.addEventListener('click', this.continuarBtnModal.bind(this));
        this.btnRecogerLocal.addEventListener('click', this.procesoBtnRecogerLocal.bind(this));
        this.btnEnvioDomicilio.addEventListener('click', this.procesoBtnEnvioDomicilio.bind(this));
        this.btnContinuarHorarioAtencion.addEventListener('click', this.verificarSiLanzaraModalSolicitudEntrega.bind(this));

        // METODOS INICIALES DEL ELEMENTO
        this.modalGeneralCarga.style.display = 'none';
        this.verificarLanzamientoModal();
        this.verificarBtnContinuar();
    }

    verificarSiLanzaraModalSolicitudEntrega() {
        this.modalMensajeHorarioAtencion.style.display = 'none';
        const modalVer = localStorage.getItem('mp-ver');
        if (modalVer != null || modalVer == 'false') {
            this.modalMensajeSolicitudEntrega.style.display = 'none';
            this.modalGeneral.style.display = 'none';
        } else {
            this.modalMensajeSolicitudEntrega.style.display = 'flex';
        }
    }

    static lanzarModalHorarioAtencion() {
        // Mostrar modal de horario de atención
        const modalMensajeHorarioAtencion = document.querySelector('#phmi-mensaje-horario-atencion');
        const modalGeneral = document.querySelector('.modal-general-sme');
        modalMensajeHorarioAtencion.style.display = 'flex';
        modalGeneral.style.display = 'flex';
        if (localStorage.getItem('ph-tipo-usuario')) {
            return;
        }
    }

    verificarLanzamientoModal() {
        const paginaActual = window.location.pathname;
        const estaEnPaginaPermitida = paginaActual == "/";

        // Actuar según el estado del horario
        const estadoHorario = localStorage.getItem('ph-horario-atencion');

        const tipoUsuario = localStorage.getItem('ph-tipo-usuario');

        // Validar turnos de atención
        const horarioGlobalAbierto = GestionSucursales.validarHorarioApertura(window.turnos_apertura_atencion);

        // Validar sucursal seleccionada
        if (window.sucursal && window.sucursal.nombre) {
            const sucursalEncontrada = window.sucursales.find(s => s.nombre === window.sucursal.nombre);
        }

        // Verificar si la sucursal específica está cerrada
        let sucursalCerrada = false;

        // Determinar qué sucursal validar: la seleccionada o la primera disponible
        let sucursalAValidar = null;
        if (window.sucursal && window.sucursal.nombre) {
            sucursalAValidar = window.sucursales.find(s => s.nombre === window.sucursal.nombre);
        } else {
            if (window.sucursales && window.sucursales.length > 0) {
                sucursalAValidar = window.sucursales[0];
            }
        }

        // Validar la sucursal (seleccionada o primera)
        if (sucursalAValidar) {
            if (!sucursalAValidar.estado) {
                sucursalCerrada = true;
            } else {
                if (sucursalAValidar.turnos && sucursalAValidar.turnos.length > 0) {
                    const turnosSucursal = sucursalAValidar.turnos.map(turno => ({
                        dias: turno.dias,
                        horaInicial: turno.horaInicial,
                        horaFinal: turno.horaFinal
                    }));
                    const sucursalAbiertaPorHorario = GestionSucursales.validarHorarioApertura(turnosSucursal);
                    sucursalCerrada = !sucursalAbiertaPorHorario;
                } else {
                    sucursalCerrada = true;
                }
            }
        }

        if ((!horarioGlobalAbierto || sucursalCerrada) && estaEnPaginaPermitida) {
            if (tipoUsuario) {
                this.modalMensajeHorarioAtencion.style.display = 'none';
                this.modalGeneral.style.display = 'none';
                return;
            }

            this.modalMensajeHorarioAtencion.style.display = 'flex';
            this.modalGeneral.style.display = 'flex';
        } else {
            this.modalMensajeHorarioAtencion.style.display = 'none';
            const modalVer = localStorage.getItem('mp-ver');

            if (modalVer === 'false') {
                this.modalMensajeSolicitudEntrega.style.display = 'none';
                this.modalGeneral.style.display = 'none';
            } else {
                this.modalMensajeSolicitudEntrega.style.display = 'flex';
                this.modalGeneral.style.display = 'flex';
            }
        }
    }

    omitirBtnModal() {
        // Ocultar el modal
        this.modalGeneral.style.display = 'none';
        // Cambiar el valor de localStorage a false
        localStorage.setItem('mp-ver', 'false');
    }

    continuarBtnModal() {
        const estaHabilitadoContinuar = !this.btnContinuar.classList.contains('desactivado');
        if (!estaHabilitadoContinuar) return;

        // Ocultar el modal
        this.modalGeneral.style.display = 'none';
        // Cambiar el valor de localStorage a false
        localStorage.setItem('mp-ver', 'false');
        window.location.href = '/pages/metodo-entrega';
    }

    procesoBtnRecogerLocal() {
        // Usar las variables globales definidas en theme.liquid
        const iconoEstadoOn = window.modalIconos?.iconoEstadoOn || '';
        const iconoEstadoOff = window.modalIconos?.iconoEstadoOff || '';

        // Se verifica si el boton precionado esta seleccionado
        const estaSeleccionadoBtnRecogerLocal = this.btnRecogerLocal.classList.contains('seleccionado');
        if (estaSeleccionadoBtnRecogerLocal) {
            this.btnRecogerLocal.classList.remove('seleccionado');
            this.iconoSeleccionRecogerLocal.innerHTML = iconoEstadoOff;
        } else {
            // Si no esta el boton seleccionado, proceder
            // Y dejar solo marcado este boton
            this.btnRecogerLocal.classList.add('seleccionado');
            this.btnEnvioDomicilio.classList.remove('seleccionado');
            this.iconoSeleccionRecogerLocal.innerHTML = iconoEstadoOn;
            this.iconoSeleccionEnvioDomicilio.innerHTML = iconoEstadoOff;
        }
        this.verificarBtnContinuar();
        localStorage.setItem('mp-ver', 'false');
    }

    procesoBtnEnvioDomicilio() {
        // Usar las variables globales definidas en theme.liquid
        const iconoEstadoOn = window.modalIconos?.iconoEstadoOn || '';
        const iconoEstadoOff = window.modalIconos?.iconoEstadoOff || '';

        // Se verifica si el boton precionado esta seleccionado
        const estaSeleccionadoBtnEnvioDomicilio = this.btnEnvioDomicilio.classList.contains('seleccionado');
        if (estaSeleccionadoBtnEnvioDomicilio) {
            this.btnEnvioDomicilio.classList.remove('seleccionado');
            this.iconoSeleccionEnvioDomicilio.innerHTML = iconoEstadoOff;
        } else {
            // Si no esta el boton seleccionado, proceder
            // Y dejar solo marcado este boton
            this.btnEnvioDomicilio.classList.add('seleccionado');
            this.btnRecogerLocal.classList.remove('seleccionado');
            this.iconoSeleccionEnvioDomicilio.innerHTML = iconoEstadoOn;
            this.iconoSeleccionRecogerLocal.innerHTML = iconoEstadoOff;
        }
        this.verificarBtnContinuar();
        localStorage.setItem('mp-ver', 'false');
    }

    verificarBtnContinuar() {
        const fueSeleccionadoBtnRecogerLocal = this.btnRecogerLocal.classList.contains('seleccionado');
        const fueSeleccionadoBtnEnvioDomicilio = this.btnEnvioDomicilio.classList.contains('seleccionado');

        if (fueSeleccionadoBtnRecogerLocal || fueSeleccionadoBtnEnvioDomicilio) {
            this.btnContinuar.classList.remove('desactivado');
        } else {
            this.btnContinuar.classList.add('desactivado');
        }

        if (fueSeleccionadoBtnRecogerLocal) {
            localStorage.setItem('seleccion-me-mi', 'local');
        }

        if (fueSeleccionadoBtnEnvioDomicilio) {
            localStorage.setItem('seleccion-me-mi', 'domicilio');
        }
    }
}

customElements.define('modal-inicial', ModalInicial);